import { render, staticRenderFns } from "./PatientList.vue?vue&type=template&id=1c043886&scoped=true"
import script from "./PatientList.vue?vue&type=script&lang=js"
export * from "./PatientList.vue?vue&type=script&lang=js"
import style0 from "./PatientList.vue?vue&type=style&index=0&id=1c043886&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c043886",
  null
  
)

export default component.exports